import React from 'react';

const Progress = () => {
    return (
        <div className="container">
            <div className="text-warning m-5 text-center">
                <h1>In Progress...........</h1>
            </div>
        </div>
    );
};

export default Progress;